import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, normalizeClass as _normalizeClass, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "row d-flex justify-content-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "input-text" }, "Tipificación", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "input-text" }, "Subtipificación", -1)
const _hoisted_4 = { class: "w-100 row d-flex justify-content-end mt-2" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Guardar ")
const _hoisted_6 = { class: "w-100 row d-flex justify-content-between mt-2 mx-0" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Expandir formulario ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Guardar ")

import { Form, FormActions } from "vee-validate";
import { env } from "@/config";
import { socket } from "@/main";
import { IConfig, IndexType } from "@/types/store";
import { Field } from "@/types/components";
import { dynamicForm } from "@/util/consts";
import { AlertModule } from "@/store/modules/Alert";
import { AuthModule } from "@/store/modules/Auth";
import { TicketModule } from "@/store/modules/Ticket";
import {
	TypificationModule,
	ISubTypification,
} from "@/store/modules/Typification";
import useFormModal from "@/composables/FormModalComposable";
import { generateDynamicSchema } from "@/store/schemas/client.schema";
import { computed, defineAsyncComponent, h, onMounted, ref, watch } from "vue";
import { TypificationModalModule } from "@/store/modules/TypificationModal";
import { AppModule } from "@/store/modules/app";
import { coreApi } from "@/conection";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const TypificationForm = env.DynamicTypification
	? defineAsyncComponent(
			() =>
				import(
					/* webpackChunckName: "typification" */ "@/callcenter/components/DynamicTypificationModal.vue"
				)
	  )
	: h("div");

// ==> Data

const formComponent = ref<
	| (FormActions<any> & {
			getValues: () => { [k: string]: string | undefined };
	  })
	| null
>(null);
const formkey = ref(0);
const model = ref({
	typification: TicketModule.currentTicket?.tipificacion ?? "",
	subtypification: TicketModule.currentTicket?.subtipificacion ?? "",
});
const showModal = ref(false);
const { getComponent, getProps, isHidden } = useFormModal();

// ==> Computed

const form = ref<IndexType<Field>>({});
const typificationConfig = computed<IConfig | undefined>(() =>
	AppModule.configs.find(c => c.name === "dynamic_typification")
);
const formData = computed<any>(() => {
	return TypificationModalModule.omniData;
});
const schema = computed(() =>
	generateDynamicSchema(Object.values(form.value as IndexType<Field>))
);
const typifications = computed(() => TypificationModule.Typifications);

const subtypifications = ref<ISubTypification[]>(
	typifications.value.find(t => {
		return t._id == model.value.typification;
	})?.subtipificacion ?? []
);

watch(
	() => [model.value.typification],
	() => {
		subtypifications.value =
			typifications.value.find(t => {
				return t._id == model.value.typification;
			})?.subtipificacion ?? [];
	}
);
watch(
	() => [TicketModule.currentRoomId, TicketModule.updated],
	() => {
		const t = TicketModule.currentTicket;
		if (env.DynamicTypification) {
			TypificationModalModule.setOmniData(t?.data ?? {});
			loadData();
		} else {
			model.value.typification = t?.tipificacion ?? "";
			model.value.subtypification = t?.subtipificacion ?? "";
		}
	}
);

// ==> Methods

function changeModal({ show }: { show: boolean }) {
	showModal.value = show;
	if (!show) loadData();
}
function openModal() {
	const values = Object.assign(
		{},
		TypificationModalModule.omniData,
		formComponent.value?.getValues()
	);
	TypificationModalModule.setOmniData(
		values as { [k: string]: string | undefined }
	);
	showModal.value = true;
}
async function mountForm() {
	let options: { [k: string]: object } | null = null;
	if (dynamicForm) {
		const dataForm = typificationConfig.value?.data ?? (await dynamicForm);
		form.value = dataForm.reduce((acc, field) => {
			acc[field.name] = field;
			if (field.type === "options" && field.staticOptions?.length) {
				const opts = field.staticOptions.reduce((acc2, option) => {
					acc2[field.name] = {
						...acc2[field.name],
						[option.label]: { value: option.value, label: option.label },
					};
					return acc2;
				}, {} as { [k: string]: Field });
				options = options ? { ...options, ...opts } : { ...opts };
			}
			return acc;
		}, {} as { [k: string]: Field });
	}
	if (options) TypificationModalModule.setOptions(options);
}
const loadData = () => {
	Object.keys(form.value).forEach(input => {
		form.value[input].value =
			formData.value[input] !== undefined && formData.value[input] !== undefined
				? formData.value[input]
				: undefined;
		/* 		form.value[input].disabled = edit.value
			? form.value[input].blockOnEdit
			: false; */
	});
};
function onInvalidSubmit(...payload: any) {
	TypificationModalModule.setAlert("Complete todos los campos restantes!");
	openModal();
}
async function onSubmit(e: any) {
	await coreApi.post("/api/ticket/typification/save", {
		data: e,
		ticketId: TicketModule.currentRoomID,
		agent_group: AuthModule.getAgentGroup?._id,
	});
}
const save = () => {
	if (model.value.typification && model.value.subtypification) {
		socket.emit("TICKET_SET_TIPIFICATION", {
			token: AuthModule.token,
			ticket: TicketModule.currentRoomID,
			tipificacion: model.value.typification,
			subtipificacion: model.value.subtypification,
		});

		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: `Se ha actualizado la tipificación y subtipificación del ticket`,
			type: "success",
		});
	} else
		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: `Debe seleccionar una tipificación y subtipificación respectivamente`,
			type: "error",
		});
};

const clearSubtypification = () => {
	model.value.subtypification = "";
};

onMounted(async () => {
	TypificationModalModule.setOmniData(TicketModule.currentTicket?.data ?? {});
	await mountForm();

	if (Object.keys(TypificationModalModule.omniData).length) loadData();
});

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!_unref(env).DynamicTypification)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_el_col, { class: "fs-base" }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_el_select, {
              disabled: _unref(TicketModule).isOldTicket,
              class: "col-12 my-2 px-0",
              size: "small",
              onChange: clearSubtypification,
              modelValue: model.value.typification,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model.value.typification) = $event)),
              placeholder: "Seleccione la tipificación"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(typifications), (typification) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: typification._id,
                    label: typification.tipificacion,
                    value: typification._id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["disabled", "modelValue"]),
            _createVNode(_component_el_col, { class: "fs-base" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_select, {
              disabled: _unref(TicketModule).isOldTicket,
              class: "col-12 my-2 px-0",
              size: "small",
              modelValue: model.value.subtypification,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model.value.subtypification) = $event)),
              placeholder: "Seleccione la subtipificación"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subtypifications.value, (subtypification) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: subtypification._id,
                    label: subtypification.subtipificacion,
                    value: subtypification._id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["disabled", "modelValue"]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_button, {
                type: "default",
                disabled: _unref(TicketModule).isOldTicket,
                onClick: save,
                plain: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ], 64))
        : (_openBlock(), _createBlock(_unref(Form), {
            class: "w-100",
            ref_key: "formComponent",
            ref: formComponent,
            key: formkey.value,
            "validation-schema": _unref(schema),
            onSubmit: onSubmit,
            onInvalidSubmit: onInvalidSubmit
          }, {
            default: _withCtx(({ values, setFieldValue }) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(form.value), (input, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["col-12", {
						'd-none':
							(_unref(typificationConfig)?.keys.indexOf(input.name) ?? -1) === -1 ||
							_unref(isHidden)(input as Field, values, setFieldValue),
					}]),
                  key: index
                }, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent((_unref(getComponent)(input.type) as any)), _mergeProps({
                    hidden: 
							(_unref(typificationConfig)?.keys.indexOf(input.name) ?? -1) === -1 ||
								(input.hidden && _unref(isHidden)(input as Field, values, setFieldValue))
						,
                    class: {
							'upload-control w-100': input.type === 'file',
							...(input.className ? { [input.className]: true } : {}),
						}
                  }, _unref(getProps)(input as Field, values), {
                    name: input.name,
                    type: input.type,
                    label: input.label,
                    placeholder: input.placeholder,
                    "small-label": ""
                  }), null, 16, ["hidden", "class", "name", "type", "label", "placeholder"]))
                ], 2))
              }), 128)),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_el_button, {
                  type: "default",
                  onClick: openModal
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "default",
                  nativeType: "submit",
                  disabled: _unref(TicketModule).isOldTicket,
                  plain: ""
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]),
            _: 1
          }, 8, ["validation-schema"]))
    ]),
    _createVNode(_Transition, {
      "enter-active-class": "miniFadeInUp",
      "leave-active-class": "miniFadeOutUp"
    }, {
      default: _withCtx(() => [
        (showModal.value)
          ? (_openBlock(), _createBlock(_unref(TypificationForm), {
              key: 0,
              "data-key": "omnichannel",
              open: showModal.value,
              onChangeModal: _cache[2] || (_cache[2] = (s) => changeModal(s))
            }, null, 8, ["open"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})